import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=83a4125a&scoped=true"
import script from "./indexCopy.vue?vue&type=script&lang=js"
export * from "./indexCopy.vue?vue&type=script&lang=js"
import style0 from "./indexCopy.vue?vue&type=style&index=0&id=83a4125a&scoped=true&lang=css"
import style1 from "./indexCopy.vue?vue&type=style&index=1&id=83a4125a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a4125a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83a4125a')) {
      api.createRecord('83a4125a', component.options)
    } else {
      api.reload('83a4125a', component.options)
    }
    module.hot.accept("./indexCopy.vue?vue&type=template&id=83a4125a&scoped=true", function () {
      api.rerender('83a4125a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicData/siteManagement/indexCopy.vue"
export default component.exports